import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: { type: String, required: true },
    duration: { type: [Number, null], required: false, default: 3000 },
    variant: { type: String, required: false, default: undefined }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

// Computed variant class
const variantClass = computed(() => {
  if (!props.variant) return '';
  return `toast-${props.variant}`;
});

const visible = ref(true);

onMounted(() => {
  // Only set timeout if duration is provided (not null for persistent toasts)
  if (props.duration !== null) {
    setTimeout(() => {
      visible.value = false;
    }, props.duration || 3000);
  }
});

const __returned__ = { props, variantClass, visible }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})